import React, { useEffect, useRef } from "react";
import Footer from "../../components/layout/Footer/Footer";
import textImg from "./text.svg";
import textImg2 from "./text2.svg";
import { motion } from "framer-motion";
import {
  Btn5,
  Container,
  Btn4,
  SmallText4,
  ImgText,
  Btn2,
  Text3,
  H11,
  H1,
  H2,
  InnerContainer,
  SmallText,
  Text,
  Btn,
  Btn1,
  Text2,
  SmallText2,
  AnimationTextContainer,
  AnimatedFrame1,
  AnimatedFrame2,
  Block1,
  Block2,
  Block1Container,
  Item,
  ItemContainer1,
  ItemContainer2,
  ItemContainer3,
  Circle,
  ItemText,
  CircleText,
  CircleContainer,
  BtnText,
  Meeting,
  Tag,
  Price,
  Circle2,
  Btn3,
  Mission,
  SmallText3,
  H112,
  H12,
  AnimatedSection,
  ScrollContainer2,
  Title,
  MainText,
  Div1,
  ImgDiv,
  TextDiv,
  Img,
  TextDiv2,
  TextDiv1,
  TextDiv4,
  TextDiv4Li,
  TextDiv3,
  CircleText1,
  Circle1,
  Cont,
  TextBlack,
  TextBlue,
  TextCont,
  TextDiv4Li2,
  Smth,
  X,
  Item2,
  ImgText2,
  PCdiv,
  Mobilediv,
  X2,
  Mobilecont,
  Div,
  Btn2Custom,
} from "./styles";
import { Cursor, useTypewriter } from "react-simple-typewriter";
import { useNavigation } from "../../types/Navigates";
import { Ratings } from "../../components/Ratings/Ratings";
import { FrmttdPrc } from "../../components/FormattedPrice/FormattedPrice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { getCard } from "../../store/slices/cardSlice";
import { getProductCategories } from "../../store/slices/productCategoriesSlice";
import { getProducts } from "../../store/slices/productsSlice";

const Main = () => {
  const refs = useRef({});
  const {
    toServices1,
    toServices2,
    toServices3,
    toServices4,
    toServices5,
    toRatings,
    toServices,
    toBlog,
  } = useNavigation();
  const block1Ref = useRef(null);
  const block2Ref = useRef(null);
  const scrollcontainerRef = useRef(null);
  const aF1Ref = useRef(null);
  const aF2Ref = useRef(null);
  const smthRef = useRef(null);
  const animBlock1Ref = useRef(null);
  const animBlock2Ref = useRef(null);
  const animBlock3Ref = useRef(null);

  useEffect(() => {
    const block1 = block1Ref.current;
    const block2 = block2Ref.current;
    const scrollcontainer = scrollcontainerRef.current;
    const aF1 = aF1Ref.current;
    const aF2 = aF2Ref.current;
    const smth = smthRef.current;
    const animBlock1 = animBlock1Ref.current;
    const animBlock2 = animBlock2Ref.current;
    const animBlock3 = animBlock3Ref.current;
    getProducts();
  }, []);

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  useEffect(() => {
    dispatch(getCard(8));
    dispatch(getProductCategories());
  }, []);
  const card = useSelector((state: RootState) => state.card.card);
  const filteredProducts = card.filter(
    (item) => item.product_category.id === 10
  );
  const filteredProducts1 = card.filter(
    (item) => item.product_category.id === 12
  );

  const productCategories = useSelector(
    (state: RootState) => state.productCategories.productCategories
  );
  const productCats = productCategories.find((item) => item.id === 10);
  const productCats1 = productCategories.find((item) => item.id === 12);

  const scroll = () => {
    if (scrollcontainerRef.current) {
      scrollcontainerRef.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollcontainerRef.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const scroll1 = () => {
    if (block1Ref.current) {
      block1Ref.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        block1Ref.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const scroll2 = () => {
    if (block2Ref.current) {
      block2Ref.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        block2Ref.current.scrollLeft += evt.deltaY;
      });
    }
  };

  const hideShowblock1 = () => {
    if (
      block1Ref.current &&
      block2Ref.current &&
      aF1Ref.current &&
      aF2Ref.current
    ) {
      block1Ref.current.style.display = "flex";
      block2Ref.current.style.display = "none";

      aF1Ref.current.style.backgroundColor = "#BFDCF5";
      aF2Ref.current.style.backgroundColor = "#ffffff";
    }
  };

  const hideShowblock2 = () => {
    if (
      block1Ref.current &&
      block2Ref.current &&
      aF1Ref.current &&
      aF2Ref.current
    ) {
      block1Ref.current.style.display = "none";
      block2Ref.current.style.display = "flex";

      aF1Ref.current.style.backgroundColor = "#ffffff";
      aF2Ref.current.style.backgroundColor = "#BFDCF5";
    }
  };

  const [text] = useTypewriter({
    words: [
      "ищешь работу заграницей",
      "нет офферов",
      "выгорание",
      "застрял и нет роста",
    ],
    loop: 0,
    typeSpeed: 50,
    deleteSpeed: 50,
  });
  const items = [
    {
      img: require("./img1.png"),
      number: "01",
      title: "Развитие карьеры",
      description:
        "Мы делимся инструментами поиска работы и развития карьеры, проводим консультации.",
      answers: [
        "Куда и как развиваться дальше?",
        "Стоит ли менять работу?",
        "Как говорить о повышении?",
        "Стоит ли принимать новый оффер?",
      ],
    },
    {
      img: require("./img2.png"),
      number: "02",
      title: "Работа с эмоциональным выгоранием",
      description:
        "Мы разберем откуда исходят низкая продуктивность, нежелание работать и страх не найти ничего лучше. Проведем диагностику ваших сильных сторон.",
      answers: [
        "Ответ как себя защитить от выгорания и преодолеть кризис в карьере",
        "Пошаговый план для личного и профессионального роста",
      ],
    },
    {
      img: require("./img3.png"),
      number: "03",
      title: "Поиск работы",
      description:
        "Мы вводим поэтапно рабочие инструменты, которые помогут достичь вашей карьерной цели.",
      answers: [
        "Сложности с поиском",
        "Отказы на собеседованиях",
        "Страх говорить о себе",
        "Релокация",
        "Неэффективное резюме и профиль LinkedIn",
      ],
    },
  ];

  const Ttoggle1 = () => {
    if (animBlock1Ref.current) {
      animBlock1Ref.current.style.display == "none"
        ? (animBlock1Ref.current.style.display = "block")
        : (animBlock1Ref.current.style.display = "none");
    }
  };
  const Ttoggle2 = () => {
    if (animBlock2Ref.current) {
      animBlock2Ref.current.style.display == "none"
        ? (animBlock2Ref.current.style.display = "block")
        : (animBlock2Ref.current.style.display = "none");
    }
  };
  const Ttoggle3 = () => {
    if (animBlock3Ref.current) {
      animBlock3Ref.current.style.display == "none"
        ? (animBlock3Ref.current.style.display = "block")
        : (animBlock3Ref.current.style.display = "none");
    }
  };

  return (
    <>
      <Container>
        <H11>
          Выведем карьеру
          <br />
          <H1>на новый уровень</H1>
        </H11>
        <H2>
          Развитие карьеры и психологическая
          <br />
          поддержка для специалистов любого уровня
          <br /> по всему миру.
        </H2>
      </Container>
      <InnerContainer $img={require("./main-bg.jpg")}>
        <Container>
          <SmallText>мы помогаем</SmallText>
          <Text>
            <Title>Хакнем систему найма, когда...</Title>
            <MainText>
              {text}
              <Cursor cursorStyle="|" />
            </MainText>
          </Text>
          <Btn href="/services">Наши услуги</Btn>
        </Container>
      </InnerContainer>
      <Container>
        <SmallText2>тарифы</SmallText2>
        <Text2>Как мы можем помочь тебе?</Text2>
        <AnimationTextContainer>
          <AnimatedFrame1 onClick={hideShowblock1} ref={aF1Ref}>
            Психология и консалтинг
          </AnimatedFrame1>
          <AnimatedFrame2 onClick={hideShowblock2} ref={aF2Ref}>
            Поиск работы
          </AnimatedFrame2>
        </AnimationTextContainer>
      </Container>
      <Block1 ref={block1Ref}>
        <Block1Container>
          {filteredProducts && productCats ? (
            filteredProducts.map((product) => (
              <Item $img={require("./item.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circle2 />
                    <CircleText>{productCats.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn1 onClick={toServices}>
                    <BtnText>Подробнее →</BtnText>
                  </Btn1>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}
        </Block1Container>
      </Block1>
      <Block2 ref={block2Ref}>
        <Block1Container>
          {filteredProducts1 && productCats1 ? (
            filteredProducts1.map((product) => (
              <Item $img={require("./item23.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circle />
                    <CircleText>{productCats1.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn1 onClick={toServices}>
                    <BtnText>Подробнее →</BtnText>
                  </Btn1>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}

          <Item2 $img={require("./item4.png")}>
            <ItemContainer1>
              <CircleContainer>
                <Circle />
                <CircleText>подбор услуги</CircleText>
              </CircleContainer>
              <ItemText>Не знаете, что вам лучше подойдет?</ItemText>
            </ItemContainer1>
            <ItemContainer2>
              Оставьте запрос, и мы окажем консультацию по услугам.
            </ItemContainer2>
            <ItemContainer3>
              <Btn2Custom href="https://t.me/ProhorovaConsult">
                <BtnText>Запросить консультацию</BtnText>
              </Btn2Custom>
            </ItemContainer3>
          </Item2>
        </Block1Container>
      </Block2>
      <Container>
        <Mission>миссия</Mission>
        <H112>
          Prohorova Consult
          <H12>– команда</H12>
          <br /> <H12>профессионалов</H12>
        </H112>
        <SmallText3>
          Мы даем бутиковый сервис развития карьеры для тех, кто ценит свой
          ресурс и стремится получать больший результат от меньших усилий.
        </SmallText3>
        <Btn3 onClick={toBlog}>Наши кейсы</Btn3>
        <Text2>Направления деятельности</Text2>
      </Container>

      <Mobilecont>
        <br />
        <hr />
        <Mobilediv>
          <TextDiv1>
            <Cont>
              <Circle1 />
              <CircleText1>01</CircleText1>
            </Cont>
            <TextCont>
              <TextBlack>Развитие карьеры</TextBlack>
            </TextCont>
            <X2 $img={require("./Icon.png")} onClick={Ttoggle1} />
          </TextDiv1>
          <Div ref={animBlock1Ref}>
            <TextDiv>
              <TextDiv2>
                Мы делимся инструментами поиска работы и развития карьеры,
                проводим консультации.
              </TextDiv2>
              <TextDiv3>Вы получаете ответы на ваши вопросы:</TextDiv3>
              <TextDiv4>
                <TextDiv4Li>
                  <TextDiv4Li>
                    <TextDiv4Li2>Куда и как развиваться дальше?</TextDiv4Li2>
                  </TextDiv4Li>

                  <TextDiv4Li>
                    <TextDiv4Li2>Стоит ли менять работу?</TextDiv4Li2>
                  </TextDiv4Li>

                  <TextDiv4Li>
                    <TextDiv4Li2>Как говорить о повышении?</TextDiv4Li2>
                  </TextDiv4Li>

                  <TextDiv4Li>
                    <TextDiv4Li2>Стоит ли принимать новый оффер?</TextDiv4Li2>
                  </TextDiv4Li>
                </TextDiv4Li>
              </TextDiv4>
            </TextDiv>
            <br />
            <br />

            <ImgDiv>
              <Img src={require("./img11.png")} />
            </ImgDiv>
          </Div>
        </Mobilediv>
        <hr />
        <Mobilediv>
          <TextDiv1>
            <Cont>
              <Circle1 />
              <CircleText1>02</CircleText1>
            </Cont>
            <TextCont>
              <TextBlack>Работа с эмоциональным выгоранием</TextBlack>
            </TextCont>
            <X2 $img={require("./Icon.png")} onClick={Ttoggle2} />
          </TextDiv1>
          <Div ref={animBlock2Ref}>
            <TextDiv>
              <TextDiv2>
                Мы разберем откуда исходят низкая продуктивность, нежелание
                работать и страх не найти ничего лучше. Проведем диагностику
                ваших сильных сторон.
              </TextDiv2>
              <TextDiv3>Вы получаете ответы на ваши вопросы:</TextDiv3>
              <TextDiv4>
                <TextDiv4Li>
                  <TextDiv4Li2>
                    Ответ как себя защитить от выгорания и преодолеть кризис в
                    карьере
                  </TextDiv4Li2>
                </TextDiv4Li>
                <TextDiv4Li>
                  <TextDiv4Li2>
                    Пошаговый план для личного и профессионального роста
                  </TextDiv4Li2>
                </TextDiv4Li>
              </TextDiv4>
            </TextDiv>
            <ImgDiv>
              <Img src={require("./img21.png")} />
            </ImgDiv>
          </Div>
        </Mobilediv>
        <hr />
        <Mobilediv>
          <TextDiv1>
            <Cont>
              <Circle1 />
              <CircleText1>03</CircleText1>
            </Cont>
            <TextCont>
              <TextBlack>Поиск работы</TextBlack>
            </TextCont>
            <X2 $img={require("./Icon.png")} onClick={Ttoggle3} />
          </TextDiv1>
          <Div ref={animBlock3Ref}>
            <TextDiv>
              <TextDiv2>
                Мы вводим поэтапно рабочие инструменты, которые помогут достичь
                вашей карьерной цели.
              </TextDiv2>
              <TextDiv3>Вы получаете ответы на ваши вопросы:</TextDiv3>
              <TextDiv4>
                <TextDiv4Li>
                  <TextDiv4Li>
                    <TextDiv4Li2>Сложности с поиском</TextDiv4Li2>
                  </TextDiv4Li>
                  <TextDiv4Li>
                    <TextDiv4Li2>Отказы на собеседованиях</TextDiv4Li2>
                  </TextDiv4Li>
                  <TextDiv4Li>
                    <TextDiv4Li2>Страх говорить о себе</TextDiv4Li2>
                  </TextDiv4Li>
                  <TextDiv4Li>
                    <TextDiv4Li2>Релокация</TextDiv4Li2>
                  </TextDiv4Li>
                  <TextDiv4Li>
                    <TextDiv4Li2>
                      Неэффективное резюме и профиль LinkedIn
                    </TextDiv4Li2>
                  </TextDiv4Li>
                </TextDiv4Li>
              </TextDiv4>
            </TextDiv>
            <br />
            <br />
            <br />

            <ImgDiv>
              <Img src={require("./img31.png")} />
            </ImgDiv>
          </Div>
        </Mobilediv>
        <hr />
        <br />
        <br />
        <br />
      </Mobilecont>

      <AnimatedSection>
        {items.map((item, index) => (
          <motion.div
            key={item.number}
            initial={{ opacity: 0, y: index % 2 === 0 ? 50 : -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: false }}
          >
            <PCdiv>
              <ImgDiv>
                <Img src={item.img} alt={item.title} />
              </ImgDiv>
              <TextDiv>
                <TextDiv1>
                  <Cont>
                    <Circle1 />
                    <CircleText1>{item.number}</CircleText1>
                  </Cont>
                  <TextCont>
                    <TextBlack>{item.title}</TextBlack>
                  </TextCont>
                </TextDiv1>
                <TextDiv2>{item.description}</TextDiv2>
                <TextDiv3>Вы получаете ответы на ваши вопросы:</TextDiv3>
                <TextDiv4>
                  {item.answers.map((answer, i) => (
                    <TextDiv4Li key={i}>
                      <TextDiv4Li2>{answer}</TextDiv4Li2>
                    </TextDiv4Li>
                  ))}
                </TextDiv4>
              </TextDiv>
            </PCdiv>

            <Mobilediv
              ref={(el) => (refs.current[`animBlock${index + 1}Ref`] = el)}
            >
              <TextDiv>
                <TextDiv1>
                  <Cont>
                    <Circle1 />
                    <CircleText1>{item.number}</CircleText1>
                  </Cont>
                  <TextCont>
                    <TextBlack>{item.title}</TextBlack>
                  </TextCont>
                  <X2 $img={require("./Icon.png")} onClick={Ttoggle1} />
                </TextDiv1>
                <TextDiv2>{item.description}</TextDiv2>
                <TextDiv3>Вы получаете ответы на ваши вопросы:</TextDiv3>
                <TextDiv4>
                  {item.answers.map((answer, i) => (
                    <TextDiv4Li key={i}>
                      <TextDiv4Li2>{answer}</TextDiv4Li2>
                    </TextDiv4Li>
                  ))}
                </TextDiv4>
              </TextDiv>
              <ImgDiv>
                <Img src={item.img} alt={item.title} />
              </ImgDiv>
            </Mobilediv>
          </motion.div>
        ))}
      </AnimatedSection>

      <InnerContainer $img={require("./main-bg.jpg")}>
        <SmallText4>Подход</SmallText4>
        <Text3>
          Подготовьтесь к успеху с персональной
          <br />
          карьерной стратегией
        </Text3>
        <ImgText src={textImg} />
        <ImgText2 src={textImg2} />
        <Btn4 href="https://t.me/ProhorovaConsult">Получить консультацию</Btn4>
      </InnerContainer>
      <br />
      <br />
      <Text2>Отзывы</Text2>
      <br />
      <br />
      <ScrollContainer2 ref={scrollcontainerRef}>
        <Ratings />
      </ScrollContainer2>
      <Btn5 onClick={toRatings}>Все отзывы</Btn5>
      <Footer />
    </>
  );
};
export default Main;
